<template>
    <canvas ref="chart" height="300" width="100"></canvas>
</template>

<script>
import Chart from 'chart.js';
import chartAPI from './../../services/sales/chart';

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export default {
    data() {
        return {
            data: [],
            backgroundColors: [" #82e0aa ", " #f8c471 ", " #5d6d7e ", " #2980b9 "],
            chart: null
        }
    },
    computed: {
        datasets() {
            const years = Array.from(new Set(this.data.map(each => each.year)));
            const data = [];

            years.forEach(year => {
                MONTHS.forEach(month => {
                    let record = this.data.find(each => each.year == year && each.month_name == month);
                    data.push({
                        year: year,
                        month: month,
                        count: record ? record.total / 1000000000  : 0
                    })
                })
            })

            return years.map((year, index) => {
                return {
                    label: year,
                    data: data.filter(each => each.year == year).map(each => ({x: each.month, y: each.count})),
                    fill: true,
                    backgroundColor: this.backgroundColors[index],
                    tension: 0.3,
                    parsing: false
                }
            })
        }
    },
    watch: {
        datasets(value) {
            this.chart.data.datasets = value;
            this.chart.update();
        }
    },
    methods: {
        renderChart() {
            this.chart = new Chart(this.$refs.chart, {
                type: "bar",
                data: {
                    labels: MONTHS,
                    datasets: []
                },
                options: {
                    maintainAspectRatio: false,
                    responsive: true,
                    title: {
                        text: "Incoming Payments Per Month (in billions)",
                        display: true
                    },
                }
            })
        },
        async fetch() {
            let res = await chartAPI.paymentMonthly();
            this.data = res.data;
        }
    },
    mounted() {
        this.renderChart();
        this.fetch();
    },
}
</script>

<style>

</style>

